import styled from "styled-components"
import NyanCat from "../assets/NyanCatZubatGame.png"
import TicTacToe from "../assets/tictactoe.PNG"
import DoodleBoard from "../assets/reels/DoodleBoard.mov"
import ECommerce from "../assets/reels/GroupProjectECommerce.mov"
import { useContext, useState, useEffect } from "react"
import { LanguageContext } from "../context/LanguageContext"

const Projects = () => {
    const { lang } = useContext(LanguageContext)
    const [codingProject, setCodingProject] = useState(DoodleBoard)
    const codingProjects = ["Doodle Board", "E-Commerce", "Nyan Cat Game", "Tic tac toe"]

    useEffect(() => {
        console.log("Project changed")
    }, [codingProject])

    return <>
    {lang === "en" ? 
    <div className="paleSections scrollable" style={{position: "relative"}}>
        <div className="hidden">
            <h2 style={{marginBottom: "2rem"}}>Coding Projects</h2>
            <div style={{display: "flex", width: "100dvw", flexWrap: "wrap", alignSelf: "stretch", alignItems: "center", justifyContent: "center"}}>
                <div style={{border: "dashed 3px var(--color-text-light)", padding: "1.5rem", textAlign: "left"}}>
                    <p style={{fontSize: "2.5rem", marginBottom: "1rem"}}>School projects</p>
                    {codingProjects.map((project) => {
                        return <div>
                                <a onClick={() => {
                                    if(project === "Doodle Board"){
                                        setCodingProject(DoodleBoard)
                                    }
                                    else if(project === "E-Commerce"){
                                        setCodingProject(ECommerce)
                                    }
                                    else if(project === "Nyan Cat Game"){
                                        setCodingProject(NyanCat)
                                    }
                                    else if(project === "Tic tac toe"){
                                        setCodingProject(TicTacToe)
                                    }
                                }}>{project}</a>
                        </div>
                    })}
                </div>
                {codingProject === DoodleBoard ? <video src={DoodleBoard} controls muted="false" style={{width:"50%", padding:"2rem"}}/> : codingProject === ECommerce ? <video src={ECommerce} controls muted="false" style={{width:"50%", padding:"2rem"}}/> : codingProject === NyanCat ? <img src={NyanCat} style={{padding:"2rem"}}/> : <img src={TicTacToe} style={{padding:"2rem"}}/>} 
            </div>
        </div>
    </div>
    :
    <div id="Projects" className="paleSections scrollable" style={{position: "relative", padding: "5rem 0"}}>
        <div className="hidden">
            <h2>Projets de programmation</h2>
            <StyledGrid>
                <div>
                    <p>Projet final - Doodle Board</p>
                        <iframe className="projects" width="560" height="315" src="https://www.youtube.com/embed/7Tyty6oGY-o?si=4lw9fIgCB9kDiW7J"></iframe>
                </div>
                <div>
                    <p>Projet de groupe - Commerce en ligne</p>
                        <iframe className="projects" width="560" height="315" src="https://www.youtube.com/embed/mg8nJJRPYtg?si=Ef3PEu6MlWZe6SNS"></iframe>
                </div>
                <div>
                    <p>Jeu Nyan Cat</p>
                        <img className="projects" src={NyanCat} />
                </div>
                <div>
                    <p>Tic Tac Toe</p>
                        <img className="projects" src={TicTacToe} />
                </div>
            </StyledGrid>
            <div>
                {lang === "en" ? <p>...And more to come!</p> : <p>...et plus à venir!</p>}
            </div>
        </div>
    </div>
    }
    </>
}

const StyledGrid = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    gap: 2rem;
    margin: 3rem 2rem;
`

export default Projects
